"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lead = exports.BodySmallLight = exports.BodySmall = exports.BodyInverse = exports.Body = exports.MediumHeading = exports.SubHeading = exports.HeaderTitle = exports.MainHeading = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var classes_1 = require("../utils/classes");
var MainHeading = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("h1", __assign({ className: classnames_1.default(classes_1.addClassName('main-heading'), 'text-4xl leading-tight', className) }, props), children));
};
exports.MainHeading = MainHeading;
var HeaderTitle = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("h1", __assign({ className: classnames_1.default(classes_1.addClassName('header-title'), 'text-3xl leading-tight font-medium', className) }, props), children));
};
exports.HeaderTitle = HeaderTitle;
// TODO: rename...
var SubHeading = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("h4", { className: classnames_1.default(classes_1.addClassName('sub-heading'), 'uppercase text-xs font-medium text-grey-lighter tracking-widest', className) }, children));
};
exports.SubHeading = SubHeading;
var MediumHeading = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("h4", { className: classnames_1.default(classes_1.addClassName('medium-heading'), 'font-medium text-xl', className) }, children));
};
exports.MediumHeading = MediumHeading;
var Body = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("p", __assign({ className: classnames_1.default(classes_1.addClassName('body'), 'text-grey-light', className) }, props), children));
};
exports.Body = Body;
var BodyInverse = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("p", __assign({ className: classnames_1.default(classes_1.addClassName('body-inverse'), 'text-white text', className) }, props), children));
};
exports.BodyInverse = BodyInverse;
var BodySmall = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("p", __assign({ className: classnames_1.default(classes_1.addClassName('body-small'), 'text-grey-light text-sm', className) }, props), children));
};
exports.BodySmall = BodySmall;
var BodySmallLight = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("p", __assign({ className: classnames_1.default(classes_1.addClassName('body-small-light'), 'text-grey-lighter text-sm', className) }, props), children));
};
exports.BodySmallLight = BodySmallLight;
var Lead = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("p", __assign({ className: classnames_1.default(classes_1.addClassName('lead'), 'text-sm text-grey-lighter', className) }, props), children));
};
exports.Lead = Lead;
//# sourceMappingURL=text.js.map